import { render, staticRenderFns } from "./SlsL_List.vue?vue&type=template&id=7c3227e7"
import script from "./SlsL_List.vue?vue&type=script&lang=js"
export * from "./SlsL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports